import { render, staticRenderFns } from "./labelingList.vue?vue&type=template&id=5140f9be&scoped=true&"
import script from "./labelingList.vue?vue&type=script&lang=js&"
export * from "./labelingList.vue?vue&type=script&lang=js&"
import style0 from "./labelingList.vue?vue&type=style&index=0&id=5140f9be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5140f9be",
  null
  
)

export default component.exports